const data = [
    {
        title: "Срочно требуется оператор девушка!!!",
        price: "от 1 000 000 сумдо 3 000 000 сум",
        location: "Ташкент, Юнусабадский район 3 авг.  Постоянная работа  Работа на полную ставку"
    },
    {
        title: "Требуется НЯНЯ в детский сад",
        price: "от 1 500 000 сумдо 1 800 000 сум",
        location: "Самарканд 3 авг.  Постоянная работа  Работа на полную ставку",
    },
    {
        title: "Apteka va do'konlarga, Sotuvchi- konsultantlikka ishga taklif qilamiz!",
        price: "от 1 500 000 сумдо 5 000 000 сум Договорная",
        location: "Наманган 1 авг.  Постоянная работа  Работа на полную ставку",
    },
]

export default data;